<script setup>

/*==================================================================*/
/*================== VUE IMPORTS ===================================*/
/*==================================================================*/

import { defineProps, defineEmits, useAttrs, useSlots, computed} from 'vue';

const attrs = useAttrs();
const slots = useSlots();

/*==================================================================*/
/*================== PROPS & EMITS =================================*/
/*==================================================================*/

const props = defineProps({
    label: {
        type: String,
        default: ''
    },
    items: {
        type: Array,
        default: () => []
    },
    itemText: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['change']);

/*==================================================================*/
/*================== HAS RETURN OBJECT =============================*/
/*==================================================================*/

const hasReturnObject = computed(() => 'return-object' in attrs);

/*==================================================================*/
/*================== HANDLERS ======================================*/
/*==================================================================*/

const onChange = (value) => {

    if(!value && hasReturnObject.value == true){
        value = {};
    }

    if(!value && hasReturnObject.value == false){
        value = "";
    }

    emit('change', value);

};

</script>

<template>
    
    <v-autocomplete
        class="c-autocomplete"
        :label="label"
        :items="items"
        :item-text="itemText"
        :disabled="props.disabled"
        hide-details
        outlined
        clearable
        v-bind="attrs"
        @change="onChange"
    >
        <template v-if="slots.item" #item="{ item }">
              <slot name="item" :item="item"></slot>
        </template>

        <template v-if="slots.selection" #selection="{ item }">
              <slot name="selection" :item="item"></slot>
        </template>

    </v-autocomplete>
</template>

<style scoped>

/*==================================================================*/
/*======================= Autocomplete =============================*/
/*==================================================================*/

.c-autocomplete{
    padding: 2px;
}

.c-autocomplete >>> .v-input__slot{
    min-height: 48px;
}

</style>
